
export const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    const options = { day: 'numeric', month: 'long' };
    const [month, day] = dateObj.toLocaleDateString('en-US', options).split(" ");
    return { day, month };
}